import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSearchParams } from 'react-router-dom';
import { fetchHistoricalApplicationsInfo } from '@actions/historicalMemberApplication/historicalApplicationsActionCreator';
import { useAppDispatch, useAppSelector } from '@hooks/index';
import { getHistoricalYears } from '../utils';
import { DEFAULT_COVERAGE_YEAR } from '../constants';
import YearSelector from '../../common/yearSelector';
import { HistoricalApplicationsContent } from '../components';


// ============================================================================
// Component
// ============================================================================

function HistoricalApplicationsPage() {
    const dispatch = useAppDispatch();
    const { historicalApplicationsInfo } = useAppSelector(state => state.historicalApplications);
    const [searchParams] = useSearchParams();
    const referenceId = searchParams.get('referenceId') || '';
    const coverageYear = searchParams.get('coverageYear') || '';

    const [currentYear, setCurrentYear] = useState<string>(coverageYear || DEFAULT_COVERAGE_YEAR);

    useEffect(() => {
        if (!referenceId || !currentYear) {
            return;
        }
        dispatch(fetchHistoricalApplicationsInfo(currentYear, referenceId));
    }, [dispatch, currentYear, referenceId]);

    // On year dropdown change - just update state, useEffect handles the fetch
    const handleYearChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setCurrentYear(event.target.value);
    };

    // Get applications from Redux store
    const applications = historicalApplicationsInfo?.myApplications || [];

    return (
        <div className="padding-3" data-testid="historical-applications-page">
            {/* Header with Year Selector */}
            <div className="display-flex flex-justify flex-align-center margin-bottom-3">
                <h2 className="margin-0">
                    <FormattedMessage id="historical.member.applications.applications" values={{ currentYear }} />
                </h2>
                <YearSelector
                    years={getHistoricalYears()}
                    currentYear={currentYear}
                    onYearChange={handleYearChange}
                    titleId="cap.applications.header.applicationYear"
                />
            </div>

            <HistoricalApplicationsContent applications={applications} />
        </div>
    );
}

export default HistoricalApplicationsPage;

